<section class="chat">
  <main class="chat-feed">
    @for (message of messages(); track message) {
    <div class="msg right-msg">
      <div class="msg-img"></div>

      <div class="msg-bubble">
        <div class="msg-info">
          <div class="msg-info-name">{{ message.user_id }}</div>
          <div class="msg-info-time">12:46</div>
        </div>

        <div class="msg-text">
          {{ message.text }}
        </div>
      </div>
    </div>
    }
  </main>

  <form class="chat-inputarea" (ngSubmit)="sendMessage()">
    <input
      matInput
      type="text"
      class="chat-input"
      placeholder="Enter your message..."
      [formControl]="messageCtrl"
    />
    <button mat-flat-button type="submit" class="chat-send-btn">Send</button>
  </form>
</section>
